import { styled } from 'styled-components';

import { colors, fontSizesByType } from 'theme/theme';

export const PhoneInputContainer = styled.div`
  --PhoneInputCountrySelect-marginRight: 0;

  .PhoneInput {
    border: 1px solid #ccc;
    border-radius: 8px;
  }

  .PhoneInputCountry {
    padding-left: 12px;
    padding-right: 12px;
    background-color: ${colors.calloutGrey};
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }

  .PhoneInputInput {
    padding: 11px 12px;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
    border: none;
    font-size: ${fontSizesByType.body[0]}px;
  }
`;
